import React from 'react';
import {
  Stack,
  Box,
  Breadcrumbs,
  Link,
  SxProps,
  Typography
} from '@mui/material';
import { QueryV2Params } from 'services/api/hooks';
import { SubscriberIndicator } from 'components/SubscriberIndicator/SubscriberIndicator';

const titleStyle: SxProps = {
  fontWeight: '700',
  fontSize: 48,
  lineHeight: '60px',
  p: 0
};

const subtitleContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

type Props = {
  prevPageTitle?: string;
  prevPagePath?: string;
  currentPageTitle?: string;
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  subscriberQueries?: QueryV2Params[];
};

/** @deprecated */
const Header: React.FC<Props> = ({
  prevPageTitle,
  prevPagePath,
  currentPageTitle,
  title,
  subtitle,
  subscriberQueries
}) => {
  return (
    <Stack sx={{ py: 0, pb: '20px' }} gap="8px">
      <Breadcrumbs aria-label="breadcrumb">
        {prevPageTitle && (
          <Link
            color="primary.main"
            href={prevPagePath || '#'}
            sx={{ textDecoration: 'none' }}
          >
            {prevPageTitle}
          </Link>
        )}
        {currentPageTitle && (
          <Typography fontSize="12px" color="customGrey.dark">
            {currentPageTitle}
          </Typography>
        )}
      </Breadcrumbs>
      <Typography sx={titleStyle}>{title}</Typography>
      <Box sx={subtitleContainer}>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
        {subscriberQueries && (
          <SubscriberIndicator subscriberQueries={subscriberQueries} />
        )}
      </Box>
    </Stack>
  );
};

export { Header };
